// @flow
import React from 'react';

import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

import { H3 } from '../Typography';

type Props = {
  text: String,
  title: string,
  combinations: Array<Object>,
}

const FAQQuestion = ({ text, title, combinations }: Props) => {
  const { t } = useTranslation();
  return (
    <div
      className={`${styles.faqContainer} 
      ${text?.isContinued ? styles.noLine : ''}
      ${text?.isNext ? styles.noIndentTop : ''}
      `}
    >
      {title
        && (
        <div className={styles.faqTitle}>
          <H3>{t(`${title}`)}</H3>
        </div>
        )}
      {text?.content
        && (
        <div
          className={styles.faqSText}
          style={{
            color: (text.color === '#0B07FF' || text.color === '#000000' || text.color === '#C31AFF') ? 'white' : 'black',
          }}
        >
          {/* eslint-disable-next-line react/no-danger */}
          <p dangerouslySetInnerHTML={{ __html: t(`${text.content}`) }} />
        </div>
      )}
      <div className={styles.faqCombinations}>
        <div className={styles.faqSlideRules}>
          <ul>
            {combinations.map((item) => (
              <li>
                {t(`${item.content}`)}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {text?.conclusion
        && (
          <div
            className={styles.faqSText}
            style={{
              color: (text.color === '#0B07FF' || text.color === '#000000' || text.color === '#C31AFF') ? 'white' : 'black',
            }}
          >
            {/* eslint-disable-next-line react/no-danger */}
            <p dangerouslySetInnerHTML={{ __html: t(`${text.conclusion}`) }} />
          </div>
)}
    </div>
  );
};

export default FAQQuestion;
